import { Stack, Text, Title } from '@mantine/core';
import { PersonelYuklemePaneli } from './PersonelYuklemePaneli';

/**
 * Portal — personel yükleme (F1.5·S12, Kapsam §18.2; ✏️ TUR 6 / P3 — #84):
 * temsilci doldurulmuş şablonu seçer, dosya SUNUCUDA satırlara çevrilir
 * (F4·S9'dan beri; eski "tarayıcınızda işlenir" cümlesi bir gizlilik
 * iddiasıydı ve YANLIŞTI). İşveren SEÇİLMEZ: sunucu, oturumdaki
 * temsilcinin firmasını işveren olarak türetir (satırda belirtilse bile yok
 * sayılır) — panel bu yüzden contractorId=null ile kurulur (sunucu ezer).
 */
export function PortalYuklemeScreen(): React.JSX.Element {
  return (
    <Stack>
      <Title order={3}>Personel yükleme</Title>
      <Text size="sm" c="dimmed" maw={640}>
        Şablonu indirin, personel listenizi doldurun ve dosyayı seçin; kayıtlar firmanız adına
        açılır. İşlenemeyen satırlar için ana firma İSG yetkilinize başvurun.
      </Text>
      <PersonelYuklemePaneli contractorId={null} />
    </Stack>
  );
}
